import styled from 'styled-components';
import { Page as BasePage } from '@hud/web-components/Layout/Page';
import { heading2 } from '@hud/web-components/DesignSystem/Typography';

const Page = styled(BasePage).attrs({
  fixedHeader: true,
  header: 'Settings',
})`
  .body {
    max-width: 980px;
    margin: 0 auto;
  }

  h2 {
    margin: 0;
    color: var(--text-standard-primary);
    ${heading2}
  }
`;

export default Page;
